import axios from "axios";
import _ from "lodash";
import Swal from "sweetalert2";
import { API_BASE_URL_RTS } from "../../constants/index.js";
import { ENDPOINT } from "../../constants/endpoint.js";

const state = {
  vessel: null,
  vessels: null,
  selectNode: null,
  loading: false,
  success: false,
  error: {},
  baseStations: [],
  navigationStatuses: [],
  shipTypes: [],
  guardZones: [],
  guardZoneNotifications: [],
  proximity: [],
  aisLoss: [],
  batteryStatus: [],
  refuelEvent: [],
  refuelReport: [],
  positionReports: [],
  detailHistory: null,
  vesselTracking: [],
  positionEventNotification: null,
  zonesRefinery: [],
  zonesBaseStation: [],
  zones: [],
  zone: [],
  vesselByMMSI: {},
  vesselGroupFishing: null,
  vesselGroupTanker: null,
  vesselById: {},
  vesselByBaseStation: [],
  positionCompareReports:[],
  detailCompareHistory:[],
  compareVessel: {},

  fishings: [],
  tankers: []
};

const mutations = {
  SET_RTS_VESSELS: (state, payload) => {
    state.vessels = payload;
  },
  SET_RTS_FISHING: (state, payload) => {
    state.fishings = payload;
  },
  SET_RTS_TANKER: (state, payload) => {
    state.tankers = payload;
  },
  SET_RTS_VESSEL: (state, payload) => {
    state.vessel = payload;
  },
  PANTO(state, payload) {
    state.selectNode = payload;
  },
  LOADING(state, payload) {
    state.loading = payload.loading;
  },
  SUCCESS(state, payload) {
    state.success = payload;
  },
  ERROR(state, payload) {
    state.error = { ...payload };
  },
  SET_RTS_BASE_STATIONS: (state, payload) => {
    state.baseStations = payload;
  },
  SET_RTS_NAVIGA_STATUS: (state, payload) => {
    state.navigationStatuses = payload;
  },
  SET_RTS_SHIP_TYPE: (state, payload) => {
    state.shipTypes = payload;
  },
  SET_RTS_GUARD_ZONE: (state, payload) => {
    state.guardZones = payload;
  },
  SET_GUARD_ZONE_NOTIFICATION: (state, payload) => {
    state.guardZoneNotifications = payload;
  },
  SET_PROXIMITY_NOTIFICATION: (state, payload) => {
    state.proximity = payload;
  },
  SET_RTS_AIS_LOSS: (state, payload) => {
    state.aisLoss = payload;
  },
  SET_RTS_BATTERY_STATUS: (state, payload) => {
    state.batteryStatus = payload;
  },
  SET_RTS_REFUEL_EVENT: (state, payload) => {
    state.refuelEvent = payload;
  },
  SET_RTS_REFUEL_REPORT: (state, payload) => {
    state.refuelReport = payload;
  },
  SET_RTS_VESSEL_POSITION_REPORT: (state, payload) => {
    state.positionReports = payload;
  },
  SET_RTS_COMPARE_VESSEL_POSITION_REPORT: (state, payload) => {
    state.positionCompareReports = payload;
  },
  SET_RTS_COMPARE_VESSEL: (state, payload) => {
    state.compareVessel = payload;
    localStorage.setItem('compareVessel', JSON.stringify(payload))
  },
  SET_RTS_DETAIL_VESSEL_POSITION_REPORT: (state, payload) => {
    state.detailHistory = payload;
  },
  SET_RTS_COMPARE_DETAIL_VESSEL_POSITION_REPORT: (state, payload) => {
    state.detailCompareHistory = payload;
  },
  SET_RTS_VESSEL_TRACKING: (state, payload) => {
    state.vesselTracking = payload;
  },
  SET_POSITION_EVENT_NOTIFICATION: (state, payload) => {
    state.positionEventNotification = payload;
  },
  CLEAR_RTS_VESSEL_POSITION_REPORT: (state, payload) => {
    state.detailHistory = payload;
    state.positionReports = [];
  },
  SET_RTS_ZONES_REFINERY: (state, payload) => {
    state.zonesRefinery = payload;
  },
  SET_RTS_ZONES_BASE_STATION: (state, payload) => {
    state.zonesBaseStation = payload;
  },
  SET_RTS_ZONES: (state, payload) => {
    state.zones = payload;
  },
  SET_RTS_ZONE: (state, payload) => {
    state.zone = payload;
  },
  SET_RTS_VESSEL_BY_MMSI(state, payload) {
    state.vesselByMMSI = { ...payload };
  },
  SET_RTS_VESSEL_GROUP_FISHING(state, payload) {
    state.vesselGroupFishing = payload;
  },
  SET_RTS_VESSEL_GROUP_TANKER(state, payload) {
    state.vesselGroupTanker = payload;
  },
  SET_RTS_VESSEL_BY_ID(state, payload) {
    state.vesselById = { ...payload };
  },
  SET_RTS_VESSEL_BY_BASE_STATION(state, payload) {
    state.vesselByBaseStation = payload;
  },
};

const actions = {
  async getRtsVesselsByMMSI(context, { mmsi, vessel, ownerVessel }) {
    console.log(mmsi, vessel, ownerVessel);
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL_BY_SHIP_TYPE;
    let config = {
      params: {
        "q[mmsi_eq]": mmsi,
      }
    };
    await axios
      .get(url, config)
      .then(async (response) => {
        console.log("getRtsVesselsByMMSI ", response.data);
        if (response.data.length != 0) {
          context.commit("ERROR", {});
          context.commit("SET_RTS_VESSEL_BY_MMSI", { data: response.data[0] });
          if (vessel) {
            const res = response.data[0];
            const ownerName = ownerVessel.personType == 'นิติบุคคล'
              ? ownerVessel.certificateOperateName
              : `${ownerVessel.title}${ownerVessel.firstName} ${ownerVessel.lastName}`;

            const ownerPhone = ownerVessel.personType == 'นิติบุคคล'
              ? ownerVessel.certificatePhoneNumber
              : ownerVessel.phoneNumber;

            res.name = vessel.name;
            res.call_sign = vessel.subName;
            res.country_id = "231";
            res.mid_id = "209";
            // res.radio_channel = "B"
            res.ship_class = "B";
            res.ship_type_id = vessel.type == "vessel" ? "31" : "81";
            res.length = vessel.size;
            res.reg_number = vessel.registrationNumber;
            // res.owner_address = "Owner address"
            res.owner_name = ownerName;
            res.owner_phone = ownerPhone;
            res.vendor_id = ownerVessel.certificateOperateName;
            // if (!vessel.mmsi) {
            //   await this.dispatch('vessels/addMMSI', {mmsi, vesselId: vessel.id, vesselRts: res});
            // } else {
            //   await this.dispatch("rts/updateVesselRts", res)
            // }
            await this.dispatch('vessels/addMMSI', { mmsi, vesselId: vessel.id, vesselRts: res });
          }

        } else {
          context.commit("SET_RTS_VESSEL_BY_MMSI", { status: 404, text: 'Not Found' });
          Swal.fire({
            icon: "warning",
            title: "ไม่พบข้อมูล MMSI",
            text: "กรุณาตรวจสอบความถูกต้อง",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsVesselsByShipType(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL_BY_SHIP_TYPE;
    let config = {
      params: {
        "q[ship_type_id_eq]": payload.shipTypeId,
        "q[name_cont]": payload.name,
        // "q[mid_code_eq]": "567",
        limit: 100
      }
    };
    await axios
      .get(url, config)
      .then((res) => {
        console.log("getRtsVesselsByShipType ", res);
        context.commit("SET_RTS_VESSELS", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsFishingByShipType(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL_BY_SHIP_TYPE;
    let config = {
      params: {
        "q[ship_type_id_eq]": payload.shipTypeId,
        "q[name_cont]": payload.name,
        limit: 100
      }
    };
    await axios
      .get(url, config)
      .then((res) => {
        console.log("getRtsFishingByShipType ", res);
        context.commit("SET_RTS_FISHING", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsTankerByShipType(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL_BY_SHIP_TYPE;
    let config = {
      params: {
        "q[ship_type_id_eq]": payload.shipTypeId,
        "q[name_cont]": payload.name,
        limit: 100
      }
    };
    await axios
      .get(url, config)
      .then((res) => {
        console.log("getRtsTankerByShipType ", res);
        context.commit("SET_RTS_TANKER", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsVessel(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL;
    let config = {
      params: {
        icon_type: "EXCISE"
      }
    };

    await axios
      .get(url, config)
      .then((res) => {
        // console.log("res vessel :: ", res);
        const vessel = _.get(res, "data", []);
        // const tanker =  _.filter(vessel, { icon_type: "tanker" });
        // console.log("tanker >>> ", tanker);
        const data = _.filter(vessel, { icon_type: payload.type });
        if (data.length > 0) {
          context.commit("SET_RTS_VESSELS", data);
        }
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsAdminVessel(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_ADMIN_VESSEL;
    let config = {
      params: {
        icon_type: "EXCISE"
      }
    };

    await axios
      .get(url, config)
      .then((res) => {
        // console.log("res vessel :: ", res);
        const vessel = _.get(res, "data", []);
        // const tanker =  _.filter(vessel, { icon_type: "tanker" });
        // console.log("tanker >>> ", tanker);
        const data = _.filter(vessel, { icon_type: payload.type });
        if (data.length > 0) {
          context.commit("SET_RTS_VESSELS", data);
        }
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  panTo(context, selectNode) {
    context.commit("PANTO", selectNode);
  },
  async getRtsBaseStations(context) {
    const url = ENDPOINT.RTS_GET_BASE_STATIONS;
    await axios
      .get(url, {
        params: {
          "q[longitude_not_null]": 1,
          "q[latitude_not_null]": 1,
          "q[mmsi_gt]": 567,
          "q[mmsi_lt]": 568,
        },
      })
      .then((response) => {
        // console.log("response.data >>>> ", response.data);
        context.commit("SET_RTS_BASE_STATIONS", response.data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsNavigationStatuses(context) {
    const url = ENDPOINT.RTS_GET_NAVIGA_STATUS;
    await axios
      .get(url, {
        params: {
          limit: 100,
        },
      })
      .then((response) => {
        // console.log("response.data >>>> ", response.data);
        context.commit("SET_RTS_NAVIGA_STATUS", response.data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsShipTypes(context) {
    const url = ENDPOINT.RTS_GET_SHIP_TYPE;
    await axios
      .get(url, {
        params: {
          limit: 100,
        },
      })
      .then((response) => {
        // console.log("response.data >>>> ", response.data);
        context.commit("SET_RTS_SHIP_TYPE", response.data);
      })
      .catch((error) => {
        console.log("Ship Types Error :", error);
      });
  },
  async getRtsGuardZone(context) {
    const url = ENDPOINT.RTS_GET_GUARD_ZONE;
    await axios
      .get(url, {
        params: {
          limit: 500,
        },
      })
      .then((response) => {
        // console.log("response.data >>>> ", response.data);
        context.commit("SET_RTS_GUARD_ZONE", response.data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getGuardZoneNotificationForNavbar({ commit }, limit) {
    console.log("limit >>> ", limit);
    const url = ENDPOINT.RTS_GET_GUARD_ZONE_NOTIFICATION;
    const config = {
      params: {
        'limit': limit
      }
    };
    await axios
      .get(url, config)
      .then(async (response) => {
        // console.log("getGuardZoneNotificationForNavbar ", response.data);
        await commit("SET_GUARD_ZONE_NOTIFICATION", response.data);
        await commit("SET_PROXIMITY_NOTIFICATION", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  async getProximityEvents({ commit }, payload) {
    console.log("payload >>> ", payload);
    const url = `${ENDPOINT.RTS_GET_PROXIMITY_EVENTS}/${payload.type.filterNotification}`;
    let config
    if (payload.type.value == "vessel") {
      config = {
        params: {
          "q[vessel_mmsi_eq]": payload.mmsiVessel,
        },
      };
    } else {
      config = {
        params: {
          "q[proximity_detection_vessel_mmsi_eq]": payload.mmsiTanker,
        },
      };
    }
    
    await axios
      .get(url, config)
      .then(async (response) => {
        console.log("getProximityEvents ", response.data);
        // await commit("SET_GUARD_ZONE_NOTIFICATION", response.data);
        await commit("SET_PROXIMITY_NOTIFICATION", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  async getRtsRefuelReportAll(context, { type, data }) {
    const url = ENDPOINT.RTS_GET_REFUEL_REPORTS;
    let config = {};
    if (type == 'battery') {
      config = {
        params: {
          'q[vessel_mmsi_eq]': data.mmsi,
          'q[record_time_gteq]': data.selectedDate.start,
          'q[record_time_lteq]': data.selectedDate.end,
          'q[battery_status_eq]': data.status.value,
          'limit': 2000
        }
      };
    } else if (type == 'ais') {
      config = {
        params: {
          'q[vessel_mmsi_eq]': data.mmsi,
          'q[record_time_gteq]': data.selectedDate.start,
          'q[record_time_lteq]': data.selectedDate.end,
          'q[ais_loss_eq]': data.status.value,
          'limit': 100
        }
      };
    }

    await axios
      .get(url, config)
      .then((response) => {
        // console.log("getRtsAisLoss >>>> ", response.data);
        const data = _.orderBy(response.data, ['record_time'], ['desc']);
        context.commit("SET_RTS_REFUEL_REPORT", data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsAisLoss(context, data) {
    const url = ENDPOINT.RTS_GET_ฺAIS_LOSS_REPORT;
    // console.log(data);
    const config = {
      params: {
        'q[vessel_mmsi_eq]': data.mmsi,
        'q[record_time_gteq]': data.selectedDate.start,
        'q[record_time_lteq]': data.selectedDate.end,
        'q[ais_loss_eq]': data.status ? data.status.id != 0 ? data.status.value : null : null,
        'limit': 100
      }
    };

    await axios
      .get(url, config)
      .then((response) => {
        // console.log("getRtsAisLoss >>>> ", response.data);
        const data = _.orderBy(response.data, ['record_time'], ['desc']);
        context.commit("SET_RTS_AIS_LOSS", data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsBatteryStatus(context, data) {
    const url = ENDPOINT.RTS_GET_ฺBATTERY_STATUS_REPORT;
    // console.log(data);
    const config = {
      params: {
        'q[vessel_mmsi_eq]': data.mmsi,
        'q[record_time_gteq]': data.selectedDate.start,
        'q[record_time_lteq]': data.selectedDate.end,
        'q[battery_status_eq]': data.status ? data.status.id != 0 ? data.status.value : null : null,
        'limit': 2000
      }
    };

    await axios
      .get(url, config)
      .then((response) => {
        // console.log("getRtsAisLoss >>>> ", response.data);
        const data = _.orderBy(response.data, ['record_time'], ['desc']);
        context.commit("SET_RTS_BATTERY_STATUS", data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsRefuelEvent(context, data) {
    const url = ENDPOINT.RTS_GET_REFUEL_REPORT;
    console.log(data);
    let config = {};
    if (!data.status || data.status.id == 0) {
      config = {
        params: {
          'q[vessel_mmsi_eq]': data.mmsi,
          'q[record_time_gteq]': data.selectedDate.start,
          'q[record_time_lteq]': data.selectedDate.end,
          'q[refuel_event_gt]': 0,
          'limit': 2000
        }
      };
    } else {
      config = {
        params: {
          'q[vessel_mmsi_eq]': data.mmsi,
          'q[record_time_gteq]': data.selectedDate.start,
          'q[record_time_lteq]': data.selectedDate.end,
          'q[refuel_event_eq]': data.status.value,
          'limit': 2000
        }
      };
    }

    await axios
      .get(url, config)
      .then((response) => {
        // console.log("getRtsAisLoss >>>> ", response.data);
        const data = _.orderBy(response.data, ['record_time'], ['desc']);
        context.commit("SET_RTS_REFUEL_EVENT", data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async readGuardZoneNotification({ commit }, id) {
    // const url = ENDPOINT.RTS_READ_GUARD_ZONE_NOTIFICATION;
    const params = new URLSearchParams({
      id: id,
    }).toString();
    const url = ENDPOINT.RTS_READ_GUARD_ZONE_NOTIFICATION + "?" + params;
    await axios
      .post(url)
      .then(async (response) => {
        console.log("response.data ", response.data);
        // await commit("SET_GUARD_ZONE_NOTIFICATION", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  async readAllGuardZoneNotification({ commit }) {
    const url = ENDPOINT.RTS_READ_ALL_GUARD_ZONE_NOTIFICATION;
    await axios
      .post(url)
      .then(async (response) => {
        console.log("response.data ", response.data);
        // await commit("SET_GUARD_ZONE_NOTIFICATION", response.data);
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  async getVesselCompareHistories(context, payload = []) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_URL_VESSEL_HISTORIES;
    const responseData = [];
    const response = await Promise.all(payload.map(async (data) => {
      const config = {
        params: {
          "q[mmsi_eq]": data.mmsi,
          record_time_gteq: data.date.start,
          record_time_lteq: data.date.end,
          interval: data.interval,
        }
      };
      return await axios.get(url, config)
        .then(async (res) => {
          console.log(res);
          const data = _.get(res, 'data', []);
          responseData.push(data);
          if (data.length) {
            const urlReport = _.get(data[0],'url', '')
            const url = `${API_BASE_URL_RTS}${urlReport}`;
            console.log('url', url);
            const interval = data.interval;
            return await axios.get(url, {
              headers: {
                "X-User-Email": "anuwat@outputstream.net",
                "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
              },
              params: {
                interval,
              },
            })
              .then((response) => {
                const positions = _.reverse(_.get(response, 'data.position_reports', []));
                return positions;
              })
              .catch((error) => {
                console.log("Error call apis :", error);
              });
          }
        })
        .catch((e) => {
          console.log(e)
        }).finally(() => {
          context.commit("LOADING", { loading: false });
        })
    }));
    if (!_.isEmpty(response)) {
      context.commit("SET_RTS_COMPARE_VESSEL_POSITION_REPORT", response);
      context.commit("SET_RTS_COMPARE_DETAIL_VESSEL_POSITION_REPORT", responseData);
    }
  },
  getVesselCompareVessel(context, payload) {
    context.commit("SET_RTS_COMPARE_VESSEL", payload);
  },
  async getVesselHistories(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = `${API_BASE_URL_RTS}${payload.url}`;
    const interval = payload.interval; //86400;
    console.log("url ", `${url}&interval=${interval}`, interval , payload.mmsi);
    await axios.get(url, {
      headers: {
        "X-User-Email": "anuwat@outputstream.net",
        "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
      },
      params: {
        interval,
      },
    })
      .then((response) => {
        // console.log("position_reports ", response.data.position_reports);
        // const positions = _.orderBy(response.data.position_reports, ['record_time'], ['asc']);
        // const positions = _.sortBy(response.data.position_reports, [ 
        //   function(o) { 
        //     console.log(moment(o.record_time, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")); 
        //     return moment(o.record_time, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss"); 
        //   }
        // ], ['asc']);
        const positions = _.reverse(response.data.position_reports);
        console.log("positions ", positions);
        context.commit("SET_RTS_VESSEL_POSITION_REPORT", positions);
        context.commit("SET_RTS_DETAIL_VESSEL_POSITION_REPORT", response.data);
      })
      .catch((error) => {
        context.commit("LOADING", { loading: false });
        console.log("Error call apis :", error);
        Swal.fire({
          icon: "warning",
          title: `ไม่พบข้อมูลการเดินเรือ ${payload.mmsi}`,
          text: `วันที่ ${payload.date.start} - ${payload.date.end}`,
          showConfirmButton: false,
        });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getVesselTracking(context, payload) {
    context.commit("LOADING", { loading: true });
    const url = `${API_BASE_URL_RTS}/vessel_reports.json`//ENDPOINT.RTS_URL_GET_VESSEL_TRACKING;
    let config = {
      headers: {
        "X-User-Email": "anuwat@outputstream.net",
        "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
      },
      params: {
        "q[mmsi_cont]": payload.mmsi,
        "q[imo_number_cont]": payload.imo,
        "q[call_sign_cont]": payload.callSign,
        "q[name_cont]": payload.vesselName,
        "q[ship_type_id_eq]": payload.shipTypeId,
        "q[vessel_groups_id_eq]": payload.vesselGroupId,
        "q[position_reports_ais_source_id_eq]": "",
        record_time_gteq: payload.date.start,
        record_time_lteq: payload.date.end,
        limit: 50
      }
    };

    await axios
      .get(url, config)
      .then(async (response) => {
        let newRes = []
        for (const [index, res] of response.data.entries()) {
            console.log("res.mmsi >>>> ", res.mmsi);
            await this.dispatch("vessels/setVessels", {mmsi: res.mmsi })
            console.log("state.vessels.vessels, ", this.state.vessels.vessels);
            const dataInFishery = this.state.vessels.vessels
            const result = {
              ...res,
              index: index,
              registration_number: dataInFishery.length != 0 ? dataInFishery[0].vessel.registrationNumber : null
            }
            console.log("result +++++ ", result);
            newRes.push(result)
          }
        console.log(" getVesselTracking:", newRes);
        context.commit("SET_RTS_VESSEL_TRACKING", newRes);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  setPositionEventNotification(context, payload) {
    context.commit("SET_POSITION_EVENT_NOTIFICATION", payload);
  },
  clearVesselHistories(context) {
    context.commit("CLEAR_RTS_VESSEL_POSITION_REPORT", null);
  },
  async getRtsZones(context) {
    const url = ENDPOINT.RTS_GET_ZONES;
    await axios
      .get(url, {
        params: {
          limit: 500,
        },
      })
      .then(async(response) => {
        context.commit("SUCCESS", false);
        let zonePolygonsRefinery = [];
        let zonePolygonsBaseStation = [];
        await _.map(response.data, async (data) => {
          if (data.url) {
            const url = data.url.slice(0, 4) + 's' + data.url.slice(4);
            // console.log("url s ::>>> ", url);

            await axios.get(url, {
              headers: {
                "X-User-Email": "anuwat@outputstream.net",
                "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
              },
            })
              .then((response) => {
                if (data.id >= 140 && data.id <= 144) {
                  zonePolygonsRefinery.push(...response.data.zone_polygons);
                } else {
                  zonePolygonsBaseStation.push(...response.data.zone_polygons);
                }
              })
              .catch((error) => {
                console.log("Error call apis :", error);
              });
          }
        });
        console.log("zones ", response.data);
        console.log("zonePolygonsRefinery ", zonePolygonsRefinery);
        await context.commit("SET_RTS_ZONES", response.data);
        await context.commit("SET_RTS_ZONES_REFINERY", zonePolygonsRefinery);
        await context.commit("SET_RTS_ZONES_BASE_STATION", zonePolygonsBaseStation);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async getRtsZoneByURL(context, url) {
    await axios.get(url, {
      headers: {
        "X-User-Email": "anuwat@outputstream.net",
        "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
      },
    })
      .then((response) => {
        // console.log("zone_polygons :: ", response.data.zone_polygons);
        context.commit("SET_RTS_ZONE", response.data.zone_polygons);
      })
      .catch((error) => {
        console.log("Error call apis :", error);
      });
  },
  async deleteRtsZone(context, id) {
    const url = `${ENDPOINT.RTS_GET_ZONES}/${id}`;
    await axios.delete(url)
      .then((response) => {
        console.log('response deleteRtsZone >> ', response.status);
        if (response.status == 200) {
          context.commit("SUCCESS", true);
        }
        // context.commit("SET_RTS_ZONES", response.data);
      })
      .catch((error) => {
        console.log("Base station Error :", error);
      });
  },
  async updateVesselRts(context, data) {
    const url = `${API_BASE_URL_RTS}/admin/vessels/${data.id}.json`;
    // console.log(url, data);
    await axios
      .put(
        url,
        data,
        {
          headers: {
            "X-User-Email": "anuwat@outputstream.net",
            "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
            "Content-Type": "application/json"
          }
        }
      )
      .then(async response => {
        console.log(" success:", response.data);
        // 567003194,567003195,567003197,567003205,567003207,567003208
        this.dispatch("rts/updateVesselGroupFishing", data);
      })
      .catch(error => {
        console.log(" error:", error);
      });
  },
  async getVesselGroupFishing(context) {
    const url = `${ENDPOINT.API_VESSEL_GROUPS}/7.json`;
    await axios
      .get(url, {
        headers: {
          "X-User-Email": "anuwat@outputstream.net",
          "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
        },
      })
      .then((response) => {
        const mmsiList = response.data.mmsi_list;
        // console.log("status call back :", mmsiList);
        context.commit("SET_RTS_VESSEL_GROUP_FISHING", mmsiList);
      })
      .catch((error) => {
        console.log('Error call apis :', error);
      });
  },
  async getVesselGroupTanker(context) {
    const url = `${ENDPOINT.API_VESSEL_GROUPS}/1.json`;
    await axios
      .get(url, {
        headers: {
          "X-User-Email": "anuwat@outputstream.net",
          "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
        },
      })
      .then((response) => {
        const mmsiList = response.data.mmsi_list;
        // console.log("status call back :", mmsiList);
        context.commit("SET_RTS_VESSEL_GROUP_TANKER", mmsiList);
      })
      .catch((error) => {
        console.log('Error call apis :', error);
      });
  },
  updateVesselGroupFishing(context, data) {
    console.log("state updateVesselGroupFishing ::: ", this.state.rts.vesselGroupFishing);
    console.log("state updateVesselGroupTanker ::: ", this.state.rts.vesselGroupTanker);
    console.log("data for update ", data.ship_type_id, data.mmsi);
    let url = '';
    let editVesselGroup = null;
    if (this.state.rts.updateVesselGroupFishing || this.state.rts.vesselGroupTanker) {
      if (data.ship_type_id == "31") {
        const stringMMSI = `${this.state.rts.vesselGroupFishing},${data.mmsi}`;
        url = `${ENDPOINT.API_VESSEL_GROUPS}/7.json`;
        editVesselGroup = {
          name: 'Excise-fishing',
          mmsi_list: stringMMSI,
          icon_type: 'fishing'
        };
      } else if (data.ship_type_id == "81") {
        const stringMMSI = `${this.state.rts.vesselGroupTanker},${data.mmsi}`;
        url = `${ENDPOINT.API_VESSEL_GROUPS}/1.json`;
        editVesselGroup = {
          name: 'Excise-tanker',
          mmsi_list: stringMMSI,
          icon_type: 'EXCISE'
        };
      }

      console.log("url editVesselGroup ::> ", url);
      console.log("editVesselGroup ::> ", editVesselGroup);
      axios
        .put(
          url,
          editVesselGroup,
          {
            headers: {
              "X-User-Email": "api@excise-online.com",
              "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
            }
          }
        )
        .then(response => {
          console.log("update ok", response.data);
          this.dispatch("rts/getVesselGroupFishing");
        })
        .catch(error => {
        });
    }
  },
  async createRtsZones(context, zone) {
    await axios
      .post(
        `${API_BASE_URL_RTS}/admin/zones.json`,
        { zone },
        {
          headers: {
            "X-User-Email": "anuwat@outputstream.net",
            "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
          }
        }
      )
      .then((response) => {
        context.commit("SUCCESS", true);
        console.log("Success ", response.data);
      })
      .catch(e => {
        console.log("error ", e);
        context.commit("SUCCESS", false);
        context.commit("ERROR", { error: e });
      });
  },
  async getRtsVesselsById(context, vesselId) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_VESSEL_BY_SHIP_TYPE;
    let config = {
      params: {
        "q[id_eq]": vesselId,
      }
    };
    await axios
      .get(url, config)
      .then(async (response) => {
        // console.log("getRtsVesselsById ",response.data);
        context.commit("SET_RTS_VESSEL_BY_ID", response.data[0]);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getRtsVesselsByBaseStations(context, baseStationId) {
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.RTS_GET_VESSELS_BY_BASE_STATION;
    let config = {
      params: {
        "q[ais_source_id_eq]": baseStationId,
      }
    };
    await axios
      .get(url, config)
      .then(async (response) => {
        // console.log("getRtsVesselsByBaseStations ",response.data);
        context.commit("SET_RTS_VESSEL_BY_BASE_STATION", response.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
